<script setup lang="ts">
    import { cn } from '../utils';
    import { InformationCircleIcon } from '@heroicons/vue/24/outline';

    const props = defineProps<{ class?: string }>();
</script>

<template>
    <button
        type="button"
        :class="cn('text-content-subdued hover:text-content-primary  rounded-full', props.class)"
    >
        <InformationCircleIcon class="size-5" />
    </button>
</template>
